import type { ImportSessionSummaryDto } from '@platewell/schema';
import { usePlatewell } from '@platewell/query';
import { Link } from '@tanstack/react-router';
import { useEffect, useState } from 'react';
import { AddRecipeOptions } from '../components/add-recipe-options.js';
import { listImportSessions } from '../lib/api.js';

const MAX_VISIBLE_SESSIONS = 5;

/** The same offer as the New Recipe page, with the household's recent imports beneath it. */
export function ImportsPage() {
  const { activeHouseholdId } = usePlatewell();
  const [sessions, setSessions] = useState<ImportSessionSummaryDto[]>([]);

  useEffect(() => {
    if (activeHouseholdId == null) {
      setSessions([]);
      return;
    }
    void listImportSessions(activeHouseholdId)
      .then(setSessions)
      .catch(() => setSessions([]));
  }, [activeHouseholdId]);

  return (
    <div className="editor" style={{ maxWidth: 560 }}>
      <h1>Import Recipes</h1>
      <AddRecipeOptions />

      {sessions.length > 0 && (
        <>
          <h2 style={{ marginTop: 28 }}>Previous Imports</h2>
          <ul className="import-session-list">
            {sessions.slice(0, MAX_VISIBLE_SESSIONS).map((session) => (
              <li key={session.id}>
                <Link
                  className="import-session-link"
                  to="/imports/$importId"
                  params={{ importId: session.id }}
                >
                  <span>{formatSessionDate(session.createdAt)}</span>
                  <span className="hint">
                    {session.successCount}/{session.fileCount} imported
                    {session.pendingCount > 0 ? ` · ${session.pendingCount} pending` : ''}
                    {session.duplicateCount > 0 ? ` · ${session.duplicateCount} duplicate` : ''}
                    {session.failCount > 0 ? ` · ${session.failCount} failed` : ''}
                  </span>
                </Link>
              </li>
            ))}
          </ul>
        </>
      )}
    </div>
  );
}

function formatSessionDate(timestamp: number): string {
  return new Date(timestamp).toLocaleString(undefined, {
    dateStyle: 'medium',
    timeStyle: 'short',
  });
}
